import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFilterStore from "@/stores/useFilterStore";
import { UPDATE_FILTER } from "@/redux/types/auth.types";

const useSyncedFilter = () => {
	const dispatch = useDispatch();
	const reduxFilter = useSelector((state) => state.auth?.filter);
	const { filter: zustandFilter, updateFilter, setFilter, resetFilter } = useFilterStore();
	const reduxEstateParentId = reduxFilter?.estate_parent_id;
	const reduxEstateId = reduxFilter?.estate_id;
	const zustandEstateParentId = zustandFilter?.estate_parent_id;
	const zustandEstateId = zustandFilter?.estate_id;

	useEffect(() => {
		const hasChanges = JSON.stringify(reduxFilter) !== JSON.stringify(zustandFilter);

		if (hasChanges) {
			dispatch({
				type: UPDATE_FILTER,
				payload: { filter: zustandFilter },
			});
		}
	}, [zustandFilter, reduxFilter, dispatch]);

	useEffect(() => {
		const isZustandEmpty = !zustandEstateParentId && !zustandEstateId;
		const hasReduxData = reduxEstateParentId || reduxEstateId;

		if (isZustandEmpty && hasReduxData) {
			setFilter(reduxFilter);
		}
	}, [reduxEstateId, reduxEstateParentId, reduxFilter, setFilter, zustandEstateId, zustandEstateParentId]);

	const syncUpdateFilter = (updates) => {
		updateFilter(updates);

		const newFilter = { ...zustandFilter, ...updates };
		dispatch({
			type: UPDATE_FILTER,
			payload: { filter: newFilter },
		});
	};

	const syncSetFilter = (newFilter) => {
		setFilter(newFilter);
		dispatch({
			type: UPDATE_FILTER,
			payload: { filter: newFilter },
		});
	};

	const syncResetFilter = () => {
		resetFilter();
		const defaultFilter = {
			estate_parent_id: "",
			estate_id: "",
			type_currency: "USD",
			search: "",
			application: "",
			parameter: "",
			unit_measurement: "kg_l",
		};
		dispatch({
			type: UPDATE_FILTER,
			payload: { filter: defaultFilter },
		});
	};

	return {
		filter: zustandFilter,
		updateFilter: syncUpdateFilter,
		setFilter: syncSetFilter,
		resetFilter: syncResetFilter,
	};
};

export default useSyncedFilter;
